import React, { useEffect } from 'react';
import { useAppContext } from '../contexts/AppContext';
import { closePopupIcon } from '../assets/superAdminAssets';
import '../style.css';

const Toaster = () => {
  const { toaster, hideToaster } = useAppContext();

  useEffect(() => {
    if (toaster.visible) {
      // Auto-hide toaster after 3 seconds
      const timer = setTimeout(() => {
        hideToaster();
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [toaster.visible, hideToaster]);

  if (!toaster.visible) return null;

  return (
    <div className={`lm-toaster ${toaster.visible ? 'toaster-visible' : ''} ${toaster.type === 'error' ? 'error' : ''}`}>
      <div className="lm-toaster-body">
        {toaster.message}
        <button type="button" onClick={hideToaster}>
          <img src={closePopupIcon} alt="Close" />
        </button>
      </div>
    </div>
  );
};

export default Toaster;
